import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MainButton from '../MUI/MainButton';
import ClaimSuccessTable from '../ClaimFormComponents/ClaimSuccessTable';

import SuccessIcon from '../../styles/svgs/succesContract.svg';
import useStyles from '../Confirmation/makeStyles';

const SuccessApplication = ({ startNewHandler, claimSuccessData }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <div className={classes.successScreen}>
        <div>
          <img src={SuccessIcon} alt="success" />
        </div>
        <div className={classes.messageSection}>
          <div className={classes.statusTitle}>{t('cmtplForm.successHeader')}</div>
          <div className={classes.subText}>{t('cmtplForm.successText')}</div>
          <div className={classes.startNewButton}>
            <MainButton
              onClick={startNewHandler}
              variant="outlined"
              color="primary"
              width="20rem"
            >
              {t('cmtplForm.startNew')}
            </MainButton>
          </div>
        </div>
      </div>

      <div className={classes.table}>
        <ClaimSuccessTable claimSuccessData={claimSuccessData} />
      </div>
    </>

  );
};

SuccessApplication.propTypes = {
  startNewHandler: PropTypes.func,
  claimSuccessData: PropTypes.arrayOf(PropTypes.shape({})),
};

SuccessApplication.defaultProps = {
  startNewHandler: () => {},
  claimSuccessData: undefined,
};

export default SuccessApplication;
